<template>
    <div class="layout">
        <LayoutHeader  ref="header"  @ready="headerReady = true" />
        <div class="layout-content" :class="{ isSHow }">
            <router-view v-if="headerReady"  />
        </div>
        <LayoutFooter  :class="{ footerIsShow: !isSHow }" />


        <Popup v-model="$store.state.show" position="bottom" round get-container="#app" @closed="handleClose">
            <div class="layout-loading" v-if="$store.state.loading">
                <div class="title">
                   {{ $t('layout.loading') }}
                    <img src="../assets/img/layout/close.png" @click="handleClose" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc">{{ $t('layout.trading') }}</div>
            </div>
         
        </Popup>
    </div>

</template>

<script>
import LayoutHeader from './header.vue'
import LayoutFooter from './footer.vue'
import { Overlay, Popup, Loading } from 'vant';
export default {
    name: 'layout',
    components: {
        LayoutHeader,
        Popup,
        LayoutFooter,
        Loading
    },
    data(){
        return{
            headerReady:false
        }
    },
    computed: {
        isSHow() {
            return ['home',
                'alliance',
                'mall',
                'me'].includes(this.$route.name)
        }
    },
    methods: {
        handleClick() {
        },
        handleClose() {
            // 设置true 会显示弹窗
            // this.$store.commit('handleShow',true)
            this.$store.commit('handleShow', false)
        }
    }
}
</script>

<style lang="less">
.layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 375px;
  
    .layout-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-x: auto;
        &.isSHow {
            padding-bottom: 82px;

        }
    }
    .footerIsShow{
        display: none;
    }
}

.loading-warp {
    position: absolute;


}

.layout-loading {
    padding: 32px 20px 80px;
    background: #000;
    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background-color: #D1A74C;
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.layout-claim {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 68px;

        >img {
            width: 137.41px;
            height: 100px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}
</style>